import t from "mitt";
const o = t();
export {
  o as emitter
};
//# sourceMappingURL=emitter.js.map
